import { StateCreator } from 'zustand';

export interface TestExecutionLayoutStore {
  testExecution: {
    activeApiTestTab: string;
    setActiveApiTestTab: (tab: string) => void;
    activeUseCaseTestTab: string;
    setActiveUseCaseTestTab: (tab: string) => void;
  };
}

export const getTestExecutionLayoutStore: StateCreator<
  TestExecutionLayoutStore,
  [['zustand/devtools', never]]
> = set => ({
  testExecution: {
    activeApiTestTab: '',
    setActiveApiTestTab: (tab: string) =>
      set(
        state => ({
          ...state,
          testExecution: {
            ...state.testExecution,
            activeApiTestTab: tab,
          },
        }),
        false,
        'testExecution/setActiveApiTestTab',
      ),
    activeUseCaseTestTab: '',
    setActiveUseCaseTestTab: (tab: string) =>
      set(
        state => ({
          ...state,
          testExecution: {
            ...state.testExecution,
            activeUseCaseTestTab: tab,
          },
        }),
        false,
        'testExecution/setActiveUseCaseTestTab',
      ),
  },
});
